module.exports = __webpack_public_path__ + "static/img/包装设计-产品包装设计.e8a4846.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10004/包装设计-产品包装设计.png
// module id = WCot
// module chunks = 1